import type { Attribute, CommonFieldProps } from '../types/form-types';
import { CommonFieldConfig } from '../types/form-types';


export function getCommonAttributes(attributes?: Attribute[]) {
    let props: CommonFieldProps = {
        label: "",
        required: false,
        description: "",
        infoIconRequired: false,
        infoIconType: "",
        infoIconText: "",
        readOnly: false,
    };

    attributes?.forEach(attr => {
        switch (attr.name) {
            case CommonFieldConfig.Label:
                props.label = attr.value;
                break;
            case CommonFieldConfig.IsRequired:
                props.required = Boolean(attr.value);
                break;
            case CommonFieldConfig.Description:
                props.description = attr.value;
                break;
            case CommonFieldConfig.InfoIconRequired:
                props.infoIconRequired = (attr.value === "TRUE")
                break;
            case CommonFieldConfig.InfoIconType:
                props.infoIconType = attr.value;
                break;
            case CommonFieldConfig.InfoIconText:
                props.infoIconText = attr.value;
                break;
            case CommonFieldConfig.ReadOnly:
                props.readOnly = Boolean(attr.value);
                break;
        }
    });

    return props;
}
